// Unauthenticated users see only the login page (rendered by Layout); there are no other public pages.
const publicRoutes = [];

export default publicRoutes;
